import { apiClient } from '@/shared/api';

import type { CampaignPage, CampaignRequest, CampaignResponse } from '../model/types';

const BASE = '/api/v1/catalog/promo/campaigns';

export interface ListCampaignsParams {
  page?: number;
  size?: number;
}

export const listCampaigns = async (params: ListCampaignsParams = {}): Promise<CampaignPage> =>
  (await apiClient.get<CampaignPage>(BASE, { params })).data;

export const createCampaign = async (body: CampaignRequest): Promise<CampaignResponse> =>
  (await apiClient.post<CampaignResponse>(BASE, body)).data;

export const getCampaign = async (campaignId: string): Promise<CampaignResponse> =>
  (await apiClient.get<CampaignResponse>(`${BASE}/${campaignId}`)).data;

export const updateCampaign = async (
  campaignId: string,
  body: CampaignRequest,
): Promise<CampaignResponse> =>
  (await apiClient.put<CampaignResponse>(`${BASE}/${campaignId}`, body)).data;

export const activateCampaign = async (campaignId: string): Promise<CampaignResponse> =>
  (await apiClient.post<CampaignResponse>(`${BASE}/${campaignId}/activate`)).data;

export const pauseCampaign = async (
  campaignId: string,
  reason?: string,
): Promise<CampaignResponse> =>
  (await apiClient.post<CampaignResponse>(`${BASE}/${campaignId}/pause`, { reason })).data;

export const endCampaign = async (campaignId: string): Promise<CampaignResponse> =>
  (await apiClient.post<CampaignResponse>(`${BASE}/${campaignId}/end`)).data;

export const archiveCampaign = async (campaignId: string): Promise<CampaignResponse> =>
  (await apiClient.post<CampaignResponse>(`${BASE}/${campaignId}/archive`)).data;
